import { Injectable } from '@angular/core';

import { Activity } from '~/core/model/activity.model';
import { ToggleService } from '~/toggles/services/toggle.service';
import { ToggleNameEnum } from '~/toggles/services/toggle/enums/name.enum';

@Injectable({
  providedIn: 'root',
})
export class AgeRequirementService {
  public tenantMajority: number;

  constructor(private readonly toggleService: ToggleService) {
    this.tenantMajority = +this.toggleService.getVariant(
      ToggleNameEnum.MajorityAge,
      '18'
    );
  }

  public adultsAllowed(activity: Activity): boolean {
    return activity.ageMax >= this.tenantMajority;
  }

  public adultsOnly(activity: Activity): boolean {
    return activity?.ageMin >= this.tenantMajority;
  }

  public childrenAllowed(activity: Activity): boolean {
    return activity?.ageMin < this.tenantMajority;
  }

  public childrenOnly(activity: Activity): boolean {
    return activity?.ageMax < this.tenantMajority;
  }
}
